import { useAuth } from '../context/AuthContext';
import {
  formatCalendarDate,
  formatDate,
  formatDateTime,
  formatNow,
  formatTime,
  resolveTimeZone,
  timezoneLabel
} from '../utils/datetime';

export const useDateTime = () => {
  const { user } = useAuth();
  const timeZone = resolveTimeZone(user?.timezone, user?.timezoneAuto);

  return {
    timeZone,
    timeZoneLabel: timezoneLabel(timeZone),
    formatDate: (value?: string | Date | null) => formatDate(value, timeZone),
    formatDateTime: (value?: string | Date | null) => formatDateTime(value, timeZone),
    formatTime: (value?: string | Date | null) => formatTime(value, timeZone),
    formatCalendarDate,
    formatNow: () => formatNow(timeZone)
  };
};
